<div *ngIf="businessDescription$ | async as businessDescription">
  <p-panel header="Business Description" styleClass="drill-down-section-header" [toggleable]="true">
    <div *ngIf="hasMultipleDatabases">
      <span class="ey-float-label">
        <select
          class="drill-down-dropdown form-select"
          #businessDescriptionSelect
          [ngModel]="selectedDatabaseId"
          (change)="onBusinessDescriptionDatabaseChange(businessDescriptionSelect.value)"
          appLabelFloat
        >
          <option *ngFor="let database of databases" [value]="database.id">
            {{ database.name }}
          </option>
        </select>
        <label>Database Source</label>
      </span>
    </div>
    <div>
      <div class="drill-down-business-desc-label">Full Overview</div>
      <div class="drill-down-business-desc-value" [innerHtml]="displayValue(businessDescription.fullOverview)"></div>
      <div class="drill-down-business-desc-label" *ngIf="!isNonBvd">Trade Description</div>
      <div class="drill-down-business-desc-value" [innerHtml]="displayValue(businessDescription.tradeDescription)" *ngIf="!isNonBvd"></div>
      <div class="drill-down-business-desc-label" *ngIf="!isNonBvd">Other Language</div>
      <div class="drill-down-business-desc-value" [innerHtml]="displayValue(businessDescription.otherLanguage)" *ngIf="!isNonBvd"></div>
    </div>
  </p-panel>
</div>
